import tools from "@/lib/tools";

interface ValidationResult {
    pattern: RegExp,
    message: String,
}

export type RegexValidatorRuleType =
    "IsPositiveInteger"
    | "IsFloat2"
    | "IsFloat82"
    | "isDigit"
    | "isPasswd"
    | "isEmail"
    | "isPhoneNumber"
    | "isSZZF"
    | 'IsValidLicense'
    | 'isNonEmpty'

export class RegexValidator {
    IsPositiveInteger(): ValidationResult {
        return {
            pattern: /^[0-9]{1,8}$/,
            message: "传入数值必须为正整数,长度只能为1-8位",
        }
    }

    IsValidLicense(): ValidationResult {
        return {
            pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
            message: "身份证不合法,请检查",
        }
    }

    IsFloat2(): ValidationResult {
        return {
            //^\d{1,7}(.\d{1,2})?$
            pattern: /^\d{1,7}(?:\.\d{0,2}$|$)/,
            message: "输入错误，整数部分长度只能为1-7位，且最多包含2位小数",
        }
    }

    IsFloat82(): ValidationResult {
        return {
            pattern: /^\d{1,8}(?:\.\d{0,2}$|$)/,
            message: "输入错误，整数部分长度只能为1-8位，且最多包含2位小数",
        }
    }

    /***
     * 验证密码
     */
    isPasswd(): ValidationResult {
        return {
            pattern: /^(\w){6,20}$/,
            message: "输入错误,只能输入6-20个字母、数字、下划线",
        }
    }

    /***
     * 验证邮箱
     */
    isEmail(): ValidationResult {
        return {
            pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
            message: "输入错误,请输入正确的邮箱",
        }
    }

    /**
     * 验证电话
     */
    isPhoneNumber(): ValidationResult {
        return {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
            message: "输入错误,请输入正确的电话号码",
        }
    }

    /**
     * 验证用户名
     */
    isSZZF(): ValidationResult {
        return {
            pattern: /^[a-zA-Z0-9]{1,20}$/,
            message: "输入错误,只能输入数字和字母，最多输入20个字符",
        }
    }

    /**
     * 校验是否全由数字组成
     */
    isDigit(): ValidationResult {
        return {
            pattern: /^\d{1,8}$/,
            message: "输入错误,只能输入8位整数",
        }
    }

    /******** @description校验银行卡号  ********/
    isBankNumber(): ValidationResult {
        return {
            pattern: /^([1-9]{1})(\d{15}|\d{16}|\d{17}|\d{18})$/,
            message: '输入错误，请输入正确的银行卡号'
        }
    }

    /**
     * @描述：邮政编码的验证
     */
    isPostCode(): ValidationResult {
        return {
            pattern: /^[1-9]\d{5}(?!\d)$/,
            message: '输入错误，请输入正确的邮政编码'
        }
    }

    /**
     * 字符串必须非空，且不能只有空格
     */
    isNonEmpty(): ValidationResult {
        return {
            pattern: /^[^\s]*[^\s]+$/,
            message: '输入错误，且字符串首尾不能为空'
        }
    }
}
